import { TargetingGroups } from '@src/application/modules/flagship/type';
import { TargetingGroup } from './TargetingGroup';
import styles from '@src/application/modules/shared/styles/CampaignSummary/CampaignSummary.module.scss';
import { TARGETINGS_COMPONENT_ID } from '@src/application/modules/shared/dataTestId';

export const TargetingsComponent = ({
  targetingGroups,
  className,
  keyIndex,
}: {
  targetingGroups: TargetingGroups[];
  className?: string;
  keyIndex?: string;
}) => {
  return (
    <div className={`${styles.targeting} ${className}`} data-testid={TARGETINGS_COMPONENT_ID}>
      {targetingGroups.map((targetingGroup, groupIndex) => {
        const isLastGroup = targetingGroups.length - 1 === groupIndex;
        return (
          <TargetingGroup
            key={`group-${groupIndex}-${keyIndex}`}
            targetingGroup={targetingGroup}
            isLastGroup={isLastGroup}
            keyIndex={keyIndex}
          />
        );
      })}
    </div>
  );
};
